import {
  CancellationReasonForMealPlan,
} from "apps/website/components/form-service/fields/helpers/cancellation-reason";

export function getCancellationReasonForMealPlan(
  primaryReason: string,
  secondaryReason: string,
): CancellationReasonForMealPlan {
  if (primaryReason === "TOO_EXPENSIVE") {
    if (secondaryReason === "OVER_MY_BUDGET") {
      return CancellationReasonForMealPlan.TOO_EXPENSIVE_OVER_MY_BUDGET;
    }
    if (secondaryReason === "OTHER_BRANDS_CHEAPER") {
      return CancellationReasonForMealPlan.TOO_EXPENSIVE_OTHER_BRANDS_ARE_CHEAPER;
    }
    if (secondaryReason === "EXPENSIVE_WORTH") {
      return CancellationReasonForMealPlan.TOO_EXPENSIVE_NOT_WORTH_THE_COST;
    }

    return CancellationReasonForMealPlan.OTHER;
  }

  if (primaryReason === "LIMITED_FREEZER_SPACE") {
    if (secondaryReason === "ACCUMULATION_OVER_TIME") {
      return CancellationReasonForMealPlan.FREEZER_SPACE_ACCUMULATION;
    }
    if (secondaryReason === "NO_MORE_ROOM") {
      return CancellationReasonForMealPlan.FREEZER_SPACE_NOT_ENOUGH_SPACE;
    }

    return CancellationReasonForMealPlan.OTHER;
  }

  if (primaryReason === "SUB_DOESNT_WORK") {
    if (secondaryReason === "NEED_LESS_FOOD_THAN_SUBSCRIPTION") {
      return CancellationReasonForMealPlan.SUBSCRIPTION_DOESNT_WORK_NEED_LESS_FOOD;
    }
    return CancellationReasonForMealPlan.OTHER;
  }

  if (primaryReason === "COMING_BACK") {
    if (secondaryReason === "COMINGBACK_MULTIFEEDING") {
      return CancellationReasonForMealPlan.COMING_BACK_FEEDING_OTHER_FOODS_ALONGSIDE_KATKIN;
    }
    return CancellationReasonForMealPlan.OTHER;
  }

  return CancellationReasonForMealPlan.OTHER;
}
